import {
    KEY_NO_ERROR,
    KEY_CELL_UNDER_VOLTAGE,
    KEY_CELL_OVER_VOLTAGE,
    KEY_OVER_TEMPERATURE_ERROR,
    KEY_CAN_COMMUNICATION_ERROR,
    KEY_MAIN_CONTACTOR_FAULTY_ERROR,
    KEY_SOC_ERROR,
    KEY_DC_BUS_OVER_CURRENT_ERROR,
    KEY_CELLS_BALANCING_ERROR,
    KEY_SLAVE_DEAD_ERROR,
    KEY_FAULTY_CHARGING_ERROR,
    KEY_REC_FAN_ERROR,
    KEY_REC_OVER_TEMPERATURE_ERROR,
    KEY_REC_OUTPUT_OVER_VOLTAGE_ERROR,
    KEY_REC_COMMAND_NOT_SEND_ERROR,
    KEY_REC_POWER_LIMIT_FLAG_ERROR,
    KEY_REC_INPUT_PHASE_LOST_ERROR,
    KEY_REC_INPUT_PHASE_UNBALANCE_ERROR,
    KEY_REC_INPUT_UNDER_VOLTAGE_ERROR,
    KEY_REC_INPUT_OVER_VOLTAGE_ERROR,
    KEY_REC_PFC_OFF_ERROR,
    KEY_OVER_LOAD_ERROR,
    KEY_SHORT_CIRCUIT_ERROR,
    KEY_OTW_ERROR,
    KEY_SOW_ERROR
} from '../utility/Constants';

export const decodeBMSError = (error) => {
    let err = KEY_NO_ERROR;

    if (error === 0) return err;
    if ((error & 1) !== 0) err = KEY_CELL_UNDER_VOLTAGE;
    if ((error & 2) !== 0) err = KEY_CELL_OVER_VOLTAGE;
    if ((error & 4) !== 0) err = KEY_OVER_TEMPERATURE_ERROR;
    if ((error & 8) !== 0) err = KEY_CAN_COMMUNICATION_ERROR;
    if ((error & 16) !== 0) err = KEY_MAIN_CONTACTOR_FAULTY_ERROR;
    if ((error & 32) !== 0) err = KEY_SOC_ERROR;
    if ((error & 64) !== 0) err = KEY_DC_BUS_OVER_CURRENT_ERROR;
    if ((error & 128) !== 0) err = KEY_CELLS_BALANCING_ERROR;
    
    console.log("Error Msg :",err)
    return err;
};

export const decodeBMSError2 = (error) => {
    let err = KEY_NO_ERROR;
    
    if (error === 0) return err;
    if ((error & 1) !== 0) err = KEY_SLAVE_DEAD_ERROR;
    if ((error & 2) !== 0) err = KEY_FAULTY_CHARGING_ERROR;
    
    return err;
};

export const decodeRectifierError1 = (error) => {
    let err = KEY_NO_ERROR;
    
    if (error === 0) return err;
    if ((error & 1) !== 0) err = KEY_REC_FAN_ERROR;
    if ((error & 2) !== 0) err = KEY_REC_OVER_TEMPERATURE_ERROR;
    if ((error & 4) !== 0) err = KEY_REC_OUTPUT_OVER_VOLTAGE_ERROR;
    if ((error & 8) !== 0) err = KEY_REC_COMMAND_NOT_SEND_ERROR;
    if ((error & 16) !== 0) err = KEY_REC_POWER_LIMIT_FLAG_ERROR;
    if ((error & 32) !== 0) err = KEY_REC_INPUT_PHASE_LOST_ERROR;
    if ((error & 64) !== 0) err = KEY_REC_INPUT_PHASE_UNBALANCE_ERROR;
    if ((error & 128) !== 0) err = KEY_REC_INPUT_UNDER_VOLTAGE_ERROR;
    
    return err;
};

export const decodeRectifierError2 = (error) => {
    let err = KEY_NO_ERROR;
    
    if (error === 0) return err;
    if ((error & 1) !== 0) err = KEY_REC_INPUT_OVER_VOLTAGE_ERROR;
    if ((error & 2) !== 0) err = KEY_REC_PFC_OFF_ERROR;
    
    return err;
};

export const decodeInverterError = (error) => {
    let err = KEY_NO_ERROR;
    
    if (error === 0) return err;
    if ((error & 1) !== 0) err = KEY_OVER_TEMPERATURE_ERROR;
    if ((error & 2) !== 0) err = KEY_OVER_TEMPERATURE_ERROR;
    if ((error & 4) !== 0) err = KEY_OVER_LOAD_ERROR;
    if ((error & 8) !== 0) err = KEY_SHORT_CIRCUIT_ERROR;
    if (error === 0x10) err = KEY_OTW_ERROR;
    if (error === 0x20) err = KEY_SOW_ERROR;
    
    return err;
};

export const processErrorData = (errorData) => {
    return {
        bmsErrorMessage: decodeBMSError(errorData.ErrorMsg),
        bmsError2Message: decodeBMSError2(errorData.ErrorMsg2),
        rectifierError1Message: decodeRectifierError1(errorData.R_Err1),
        rectifierError2Message: decodeRectifierError2(errorData.R_Err2),
        inverterErrorMessage: decodeInverterError(errorData.Err),
        hasErrors: errorData.ErrorMsg !== 0 || 
                  errorData.ErrorMsg2 !== 0 || 
                  errorData.R_Err1 !== 0 || 
                  errorData.R_Err2 !== 0 || 
                  errorData.Err !== 0
    };
};

export const getErrorSeverity = (errorData) => {
    if (!errorData.hasErrors) return 'success';
    if (errorData.ErrorMsg > 0 || errorData.ErrorMsg2 > 0) return 'error';
    if (errorData.R_Err1 > 0 || errorData.R_Err2 > 0) return 'warning';
    if (errorData.Err > 0) return 'warning';
    return 'info';
};

export const getAllActiveErrors = (errorData) => {
    const activeErrors = [];
    
    if (errorData.ErrorMsg > 0) {
        activeErrors.push({
            type: 'BMS Error',
            message: decodeBMSError(errorData.ErrorMsg)
        });
    }
    
    if (errorData.ErrorMsg2 > 0) {
        activeErrors.push({
            type: 'BMS Error 2',
            message: decodeBMSError2(errorData.ErrorMsg2)
        });
    }
    
    if (errorData.R_Err1 > 0) {
        activeErrors.push({
            type: 'Rectifier Error 1',
            message: decodeRectifierError1(errorData.R_Err1)
        });
    }
    
    if (errorData.R_Err2 > 0) {
        activeErrors.push({
            type: 'Rectifier Error 2',
            message: decodeRectifierError2(errorData.R_Err2)
        });
    }
    
    if (errorData.Err > 0) {
        activeErrors.push({
            type: 'Inverter Error',
            message: decodeInverterError(errorData.Err)
        });
    }
    
    return activeErrors;
};
